import {
  Anchor, Bath, Snowflake, Crosshair, Navigation, Bed, Mountain,
  Waves, ChefHat, Refrigerator, Music, Sailboat, Box, Radar,
  Fish, GlassWater, UserCheck, FileBadge, Sandwich,
  Car, Baby, Trophy, Recycle,
} from "lucide-react";

const AVAILABLE = [
  ["Toilet", "Private electric flush", Bath],
  ["Air conditioning", "Climate-controlled cabin", Snowflake],
  ["Fighting chair", "Tournament-grade", Crosshair],
  ["GPS", "Full electronics suite", Navigation],
  ["Bed", "Private V-berth", Bed],
  ["Flybridge", "Upper helm + lounge", Mountain],
  ["Snorkeling gear", "On request", Waves],
  ["Kitchen", "Stocked galley", ChefHat],
  ["Refrigerator", "Cold drinks all day", Refrigerator],
  ["Multimedia system", "Bluetooth audio", Music],
  ["Outriggers", "Spread for trolling", Sailboat],
  ["Ice box", "Catch storage", Box],
  ["Radar", "Weather + traffic", Radar],
];

const INCLUDED = [
  ["Rods, reels & tackle", "Full setup provided", Fish],
  ["Lures", "Crew rigs to conditions", Crosshair],
  ["Drinks", "Beer & water on ice", GlassWater],
  ["First mate + crew", "Captain, First Mate, 2 Anglers", UserCheck],
  ["Fishing license", "Covered by vessel registration", FileBadge],
  ["Lunch", "Included on full-day trips", Sandwich],
];

const POLICIES = [
  ["Pickup", "Arranged at reservation — Ocho Rios marinas & resorts", Car],
  ["Child friendly", "Yes — with signed waiver", Baby],
  ["You keep the catch", "Shared equally with the crew", Trophy],
  ["Catch & release", "Captain's call on certain marlin", Recycle],
];

function ItemList({ items, testid }) {
  return (
    <ul className="space-y-4" data-testid={testid}>
      {items.map(([label, sub, Icon]) => (
        <li key={label} className="flex items-start gap-3">
          <span
            className="shrink-0 inline-flex items-center justify-center"
            style={{
              width: 36, height: 36, borderRadius: 2,
              background: "rgba(201, 162, 74, 0.12)",
              color: "var(--aq-gold)",
            }}
          >
            <Icon size={18} />
          </span>
          <div>
            <div className="text-[15px] font-medium" style={{ color: "var(--aq-navy)" }}>{label}</div>
            <div className="text-[13px]" style={{ color: "var(--aq-text-soft)" }}>{sub}</div>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default function Amenities() {
  return (
    <section id="amenities" data-testid="amenities-section" className="aq-section aq-bg-foam">
      <div className="aq-container">
        <span className="aq-overline">On Board · Included · Policies</span>
        <h2 className="aq-h2 text-4xl sm:text-5xl mt-4" style={{ color: "var(--aq-navy)" }}>
          Everything you need, nothing you don't.
        </h2>
        <span className="aq-divider" />

        <div className="grid lg:grid-cols-3 gap-6 mt-12">
          <div className="aq-card p-8" data-testid="amenities-onboard-card">
            <Anchor size={22} style={{ color: "var(--aq-gold)" }} />
            <h3 className="aq-serif text-2xl mt-4 mb-2" style={{ color: "var(--aq-navy)" }}>Available on board</h3>
            <p className="text-sm mb-6" style={{ color: "var(--aq-text-soft)" }}>
              The vessel comes fully outfitted for a serious day at sea.
            </p>
            <ItemList items={AVAILABLE} testid="amenities-onboard-list" />
          </div>

          <div className="aq-card p-8" data-testid="amenities-included-card">
            <Fish size={22} style={{ color: "var(--aq-gold)" }} />
            <h3 className="aq-serif text-2xl mt-4 mb-2" style={{ color: "var(--aq-navy)" }}>Included in trip price</h3>
            <p className="text-sm mb-6" style={{ color: "var(--aq-text-soft)" }}>
              Show up with sunscreen and a smile. We've got the rest.
            </p>
            <ItemList items={INCLUDED} testid="amenities-included-list" />
          </div>

          <div className="aq-card p-8" data-testid="amenities-policies-card">
            <FileBadge size={22} style={{ color: "var(--aq-gold)" }} />
            <h3 className="aq-serif text-2xl mt-4 mb-2" style={{ color: "var(--aq-navy)" }}>Listing policies</h3>
            <p className="text-sm mb-6" style={{ color: "var(--aq-text-soft)" }}>
              House rules &mdash; written by anglers, not lawyers.
            </p>
            <ItemList items={POLICIES} testid="amenities-policies-list" />
          </div>
        </div>
      </div>
    </section>
  );
}
